const TOKEN_KEY = 'pumpkin_access_token';
const REFRESH_TOKEN_KEY = 'pumpkin_refresh_token';
const USER_KEY = 'pumpkin_user';

export const tokenStorage = {
  getToken: (): string | null => sessionStorage.getItem(TOKEN_KEY),
  setToken: (token: string): void => sessionStorage.setItem(TOKEN_KEY, token),
  clearToken: (): void => sessionStorage.removeItem(TOKEN_KEY),

  getRefreshToken: (): string | null => sessionStorage.getItem(REFRESH_TOKEN_KEY),
  setRefreshToken: (refreshToken: string): void => sessionStorage.setItem(REFRESH_TOKEN_KEY, refreshToken),
  clearRefreshToken: (): void => sessionStorage.removeItem(REFRESH_TOKEN_KEY),

  getUser: <T>(): T | null => {
    const raw = sessionStorage.getItem(USER_KEY);
    if (!raw) return null;
    try { return JSON.parse(raw) as T; } catch { return null; }
  },
  setUser: <T>(user: T): void => sessionStorage.setItem(USER_KEY, JSON.stringify(user)),
  clearUser: (): void => sessionStorage.removeItem(USER_KEY),

  clear: (): void => {
    sessionStorage.removeItem(TOKEN_KEY);
    sessionStorage.removeItem(REFRESH_TOKEN_KEY);
    sessionStorage.removeItem(USER_KEY);
  },
};
